import {React,  useEffect } from "react";
import CardLayout from "../../../components/ReusableComponents/CardLayout";
import DoughnutChart from "../../../components/ReusableComponents/DoughnutChart";
import { ChartCardContent } from "../../dashboard/dashboard.styled";
import { CardWrapper } from "../../apprenticeship/Apprenticeship.styled";
import { toast } from "react-toastify";
import ChartlabelALT from "../../../components/ReusableComponents/ChartlabelALT";
import { DoughnutChartOptions } from "../../../Constants";
import { useDispatch, useSelector } from "react-redux";
import { updateCustCharts } from "../CustomerSlice";
import { fetchChartData } from "../customersUtils";

function CustomerCharts() {

    useEffect(() => {
		getChartData();
	}, []);

    const chartInfo = useSelector((state) => state.customers.chart.info);
	const totalValue = useSelector((state) => state.customers.chart.totalValue);

	
	const dispatch = useDispatch();

	const chart1Data = {
		labels: ["Profiled customers", "Non-profiled customers"],
		datasets: [
			{
				label: "customers",
				data: [chartInfo.profiledUsers, chartInfo.nonProfiledUsers],
				backgroundColor: ["#0091BF", "#BAD8D4"],
			},
		],
		totalValue: totalValue.chart1,
	};

// eslint-disable-next-line no-unused-vars
	const chart2Data = {
		labels: ["Customers-per-Time", "Total Customers"],
		datasets: [
			{
				label: "customers",
				data: [chartInfo.customersPerTime, chartInfo.totalCustomers],
				backgroundColor: ["#004A8E", "#8CB68B"],
			},
		],
		totalValue: totalValue.chart2,
	};

	

    const getChartData = async () => {
		try {
			// eslint-disable-next-line no-unused-vars
			const chartInfo = await fetchChartData();
			if (chartInfo?.result) {
				let result = {
					info: {
						profiledUsers: chartInfo.result?.profiledUsers,
						nonProfiledUsers: chartInfo.result?.nonProfiledUsers,
						customersPerTime: chartInfo.result?.customersPerTime,
						totalCustomers: chartInfo.result?.totalCustomers,
					},
					totalValue: {
						chart1: chartInfo.result?.profiledUsers + chartInfo.result?.nonProfiledUsers,
						chart2: chartInfo.result?.customersPerTime + chartInfo.result?.totalCustomers,
					},
				};
				dispatch(updateCustCharts(result));
			}
		} catch (error) {
			console.log(error);
			toast.error("unable to fetch charts data");
		}
	};

  return (
    <CardWrapper>
			<CardLayout type='Customers'>
				<ChartCardContent firstcolor='#0091BF' secondcolor='#BAD8D4'>
					<DoughnutChart totalAmount={totalValue.chart1} data={chart1Data} options={DoughnutChartOptions} />
					<ChartlabelALT
						firstColorId={"#0091BF"}
						firstCaption={"Profiled customers"}
						firstAmount={chartInfo?.profiledUsers}
						secondColorId={"#BAD8D4"}
						secondCaption={"Non-profiled customers"}
						secondAmount={chartInfo?.nonProfiledUsers}
						totalAmount={totalValue.chart1}
						customLabel={"customer(s)"}
					/>
				</ChartCardContent>
			</CardLayout>

			{/* <CardLayout type='Number of customers'>
				<ChartCardContent firstcolor='#004A8E' secondcolor='#8CB68B'>
					<DoughnutChart totalAmount={totalValue.chart2} data={chart2Data} options={DoughnutChartOptions} />
					<ChartlabelALT
						firstColorId={"#004A8E"}
						firstCaption={"Customers-per-time"}
						firstAmount={chartInfo?.customersPerTime}
						secondColorId={"#8CB68B"}
						secondCaption={"Total customers"}
						secondAmount={chartInfo?.totalCustomers}
						totalAmount={totalValue.chart2}
						customLabel={"customers"}
					/>
				</ChartCardContent>
			</CardLayout> */}
		</CardWrapper>
  )
}

export default CustomerCharts